import React, { Component } from 'react';
import { connect } from 'react-redux';
import { scroller } from 'react-scroll';
import WidgetPreviewCompareModal from '../../../../views/widget/common/modal/WidgetPreviewCompareModal';
import withModal from '../../../../lib/hoc/withModal';
import { widgetActions } from '../../../../store/modules/widget';
import { WIDGET_PREVIEW_COMPARE_SECTION_ID_ACTIVE_STATE } from '../../../../constants/service/app/widgetConstants';

class WidgetPreviewCompareModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentActivePageWidgetId: props.data.pageWidgetPreviewDataList[0].widgetInfo.widgetId,
      settingTimeActivePageWidgetId: props.data.pageWidgetPreviewDataList[0].widgetInfo.widgetId,
    };
  }

  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({ name: 'widgetPreviewCompareModal', value: false });
  };

  /**
   *  특정 패널을 스크롤 상위로 올리기
   */
  scrollToTargetTop = (widgetId, sectionId) => {
    /**
     *  특정 버전의 패널을 각각 스크롤 상위로 이동시킨다.
     */
    scroller.scrollTo(`${sectionId}-${widgetId}`, {
      smooth: true,
      containerId: sectionId,
    });

    this.setState({
      [WIDGET_PREVIEW_COMPARE_SECTION_ID_ACTIVE_STATE[sectionId]]: widgetId,
    });
  };

  render() {
    return (
      <WidgetPreviewCompareModal
        {...this.state}
        {...this.props}
        scrollToTargetTop={this.scrollToTargetTop}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.widget.widgetPreviewCompareModal.isOpen,
    data: state.widget.widgetPreviewCompareModal.data,
  };
};

const mapDispatchToProps = {
  setData: widgetActions.setData,
  toggleModal: widgetActions.toggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(WidgetPreviewCompareModalContainer));
